<template>
  <div>
    <v-simple-table dense>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">Competência</th>
            <th class="text-right">Valor</th>
            <th class="text-right">Renegociação</th>
            <th class="text-right">Add/Desc</th>
            <th class="text-right">Juros</th>
            <th class="text-right">Total</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="i in numberOfInstallments"
            :key="i"
          >
            <td class="text-left"><b>{{ getNextMonth(i) }}</b></td>
            <td class="text-right">{{ monthlyValue(i).value | price }}</td>
            <td class="text-right">{{ monthlyValue(i).renegotiation | price }}</td>
            <td class="text-right">{{ monthlyValue(i).additional - monthlyValue(i).discount | price }}</td>
            <td class="text-right">{{ monthlyValue(i).interest | price }}</td>
            <td class="text-right"><b>{{ monthlyValue(i).total | price }}</b></td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'printFundraisings',
  props: {
    participantId: {
      type: String
    },
    joineds: {
      type: Array
    }
  },
  data () {
    return {
      loading: false,
      joinedItems: []
    }
  },
  computed: {
    numberOfInstallments () {
      let numberOfInstallments = 0
      for (const index in this.joinedItems) {
        const joined = this.joinedItems[index]
        if (joined.number_of_installment && joined.number_of_installment > numberOfInstallments) {
          numberOfInstallments = joined.number_of_installment
        }
      }
      return numberOfInstallments
    }
  },
  methods: {
    getNegotiationData (index, page) {
      const newJoined = { ...this.joinedItems[index] }

      axios.get(`/financial-negotiations?page[size]=30&page[number]=${page}&filter[joined_id]=${newJoined.joined_id}`)
        .then(response => {
          if (response.data) {
            const data = response.data.data
            const meta = response.data.meta

            if (data) {
              newJoined.negotiations = [...newJoined.negotiations, ...data]
              this.$set(this.joinedItems, index, newJoined)
            }

            if (meta && meta.current_page < meta.last_page) {
              this.getNegotiationData(index, page + 1)
            } else {
              newJoined.loading_provisioning_itens = false
              this.$set(this.joinedItems, index, newJoined)
              this.setProvisioningTotals(index)
            }
          }
        })
        .catch(() => {
          newJoined.loading_provisioning_itens = false
          this.$set(this.joinedItems, index, newJoined)
        })
    },
    setProvisioningTotals (index) {
      const newJoined = { ...this.joinedItems[index] }
      newJoined.provisioning_renegotiation = 0
      newJoined.provisioning_additional = 0
      newJoined.provisioning_discount = 0
      newJoined.provisioning_interest_and_fines = 0
      newJoined.has_previous_provisioning = false
      newJoined.has_more_provisioning = false

      for (const i in newJoined.negotiations) {
        const item = newJoined.negotiations[i]

        if (!item.generated_invoice && item.category === 'renegotiation') {
          newJoined.provisioning_renegotiation += item.installment_amount
        }

        if (!item.generated_invoice && item.category === 'additional') {
          newJoined.provisioning_additional += item.installment_amount
        }

        if (!item.generated_invoice && item.category === 'discount') {
          newJoined.provisioning_discount += item.installment_amount
        }

        if (!item.generated_invoice && item.category === 'interest_and_fines') {
          newJoined.provisioning_interest_and_fines += item.installment_amount
        }
      }

      this.$set(this.joinedItems, index, newJoined)
    },
    actualMoment () {
      let actualMoment = this.$moment()
      const actualDay = parseInt(actualMoment.format('D'))
      if (actualDay < 5) actualMoment.subtract(1, 'months')
      return actualMoment
    },
    getNextMonth (i) {
      const momentMonth = this.$moment(this.actualMoment())
      momentMonth.add(i, 'months')
      return momentMonth.format('MM/YYYY')
    },
    monthlyValue (i) {
      const momentMonth = this.$moment(this.actualMoment())
      momentMonth.add(i, 'months')

      let value = 0
      let renegotiation = 0
      let additional = 0
      let discount = 0
      let interest = 0

      for (const index in this.joinedItems) {
        const joined = { ...this.joinedItems[index] }
        const monthlyNegotiations = joined.negotiations.filter(e => !e.generated_invoice && this.$moment(e.due_date).format('YYYYMM') === momentMonth.format('YYYYMM'))
        let futureValue = joined.amount_to_pay
        if (joined.total_paid) futureValue -= joined.total_paid
        if (joined.total_late) futureValue -= joined.total_late
        if (joined.total_pending) futureValue -= joined.total_pending
        if (joined.provisioning_renegotiation) futureValue -= joined.provisioning_renegotiation
        if (joined.provisioning_additional) futureValue -= joined.provisioning_additional
        if (joined.provisioning_discount) futureValue += joined.provisioning_discount

        const installments = (joined.number_of_installment) || 0
        value += (installments) ? futureValue / installments : 0

        if (monthlyNegotiations.length > 0) {
          for (const i in monthlyNegotiations) {
            const item = monthlyNegotiations[i]
            if (item.category === 'renegotiation') renegotiation += item.installment_amount
            if (item.category === 'additional') additional += item.installment_amount
            if (item.category === 'discount') discount += item.installment_amount
            if (item.category === 'interest_and_fines') interest += item.installment_amount
          }
        }
      }

      return {
        value,
        renegotiation,
        additional,
        discount,
        interest,
        total: value + renegotiation + additional - discount + interest
      }
    }
  },
  mounted () {
    if (this.joineds && this.joineds.length > 0) this.joinedItems = [...this.joineds]
    else this.joinedItems = []

    if (this.joinedItems.length > 0) {
      for (const i in this.joinedItems) {
        const newJoined = { ...this.joinedItems[i] }
        newJoined.loading_provisioning_itens = true
        newJoined.negotiations = []
        this.$set(this.joinedItems, i, newJoined)
        setTimeout(() => {
          this.getNegotiationData(i, 1)
        }, 1000)
      }
    }
  }
}
</script>
